import { MDText } from 'i18n-react';

import { ReactComponent as TpLogo } from '../../../../../../../client/assets_seller/trustpilot/trustpilot-logo-original-2022.svg';
import { ReactComponent as TpStars } from '../../../../../../../client/assets_seller/trustpilot/trustpilot-stars-4.5-2022.svg';
import { useTrustpilot } from '../../../../fastlane/trustpilotCommon/useTrustpilot';
import LocalTexts from '../CompanyStats.texts.json';

import styles from './SocialValidation.scss';

const LocalT = new MDText(LocalTexts.socialValidation);

export const SocialValidation = () => {
  const { tpData } = useTrustpilot();

  return (
    <div aria-label="Trustpilot rating" className={styles.socialValidation} role="group">
      <span className={styles.score}>{tpData?.rating}</span>
      <div>
        <div className={styles.logoRating}>
          <TpLogo aria-label="Trustpilot" height="20" role="img" width="97" />
          <TpStars aria-label="Trustpilot star rating" height="20" role="img" width="108" />
        </div>
        <p data-thc-style-override className={styles.message}>{LocalT.translate('reviewsCount')}</p>
      </div>
    </div>
  );
};
